const getLayers = (layers, paragraphRef) => {
    if (Object.keys(layers).includes(paragraphRef)) {
        return layers[paragraphRef];
    } else {
        return [];
    }
}

export default getLayers;